(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-blend-hero"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. The guard keeps a save
   from registering a second set of document listeners. */
if (!window.__bwBlendHeroBound) {
  window.__bwBlendHeroBound = true;
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function current() {
      return document.documentElement.getAttribute('data-bw-blend') === 'restore' ? 'restore' : 'move';
    }

    /* Everything below is enhancement only. CSS already renders the correct
       blend; this adds the in-flight shadow drop and syncs aria-pressed. */
    function flourish() {
      document.querySelectorAll('[data-bw-blend-hero]').forEach(function (root) {
        var rail = root.querySelector('[data-bw-packets]');
        if (rail && !reduce.matches) {
          rail.classList.add('is-swapping');
          clearTimeout(rail._bwTimer);
          var ms = parseInt(getComputedStyle(root).getPropertyValue('--bwbh-swap-ms'), 10) || 620;
          rail._bwTimer = setTimeout(function () { rail.classList.remove('is-swapping'); }, ms);
        }
        root.querySelectorAll('[data-bw-blend-set]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.bwBlendSet === current()));
        });
      });
    }

    /* Transitions are enabled a frame after paint so the initial park does not
       animate in from off-screen on load. */
    function ready() {
      document.querySelectorAll('[data-bw-blend-hero] [data-bw-packets]').forEach(function (rail) {
        requestAnimationFrame(function () { rail.classList.add('is-ready'); });
      });
      document.querySelectorAll('[data-bw-blend-hero]').forEach(function (root) {
        if (root.dataset.bwTilt === '1' || reduce.matches) return;
        root.dataset.bwTilt = '1';
        var stage = root.querySelector('[data-bw-stage]');
        if (!stage) return;

        var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

        stage.addEventListener('mouseenter', function () {
          root.style.setProperty('--bwbh-tilt', (Math.random() * 7 - 3.5).toFixed(2) + 'deg');
        });

        /* Touch: tap to enlarge, tap again to release. CSS keeps :hover away
           from coarse pointers, so this class is the only thing holding the
           pose and the second tap genuinely clears it. The tilt is re-rolled on
           the way in only, matching what mouseenter does. */
        stage.addEventListener('click', function () {
          if (fine.matches) return;
          if (stage.classList.toggle('is-tapped')) {
            root.style.setProperty('--bwbh-tilt', (Math.random() * 7 - 3.5).toFixed(2) + 'deg');
          }
        });
      });
      document.querySelectorAll('[data-bw-blend-hero] [data-bw-blend-set]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.bwBlendSet === current()));
      });
    }

    document.addEventListener('bw:blendchange', flourish);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bw-blend-hero] [data-bw-blend-set]');
      if (!btn) return;
      var v = btn.dataset.bwBlendSet;
      if (document.documentElement.getAttribute('data-bw-blend') === v) return;
      document.documentElement.setAttribute('data-bw-blend', v);
      try { localStorage.setItem('bw-blend', v); } catch (err) {}
      document.dispatchEvent(new CustomEvent('bw:blendchange', { detail: { blend: v } }));
    });

    /* Editor: re-arm after a re-render, and switch to the blend whose block
       the merchant just selected so they can see what they are editing. */
    document.addEventListener('shopify:section:load', ready);

    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      if (!el || !el.closest || !el.closest('[data-bw-blend-hero]')) return;
      var key = el.getAttribute('data-b');
      if (!key) return;
      if (document.documentElement.getAttribute('data-bw-blend') === key) return;

      /* localStorage MUST be written here, not just the attribute.

         The header's inline script runs on every render and sets the
         attribute from localStorage. Setting only the attribute meant the
         header reset it on the next render, the editor re-fired select, this
         handler set it again — an unbounded ping-pong between two scripts,
         triggered precisely by selecting the block for the blend that is not
         currently active. */
      try { localStorage.setItem('bw-blend', key); } catch (err) {}
      document.documentElement.setAttribute('data-bw-blend', key);
      document.dispatchEvent(new CustomEvent('bw:blendchange', { detail: { blend: key } }));
    });

    if (document.readyState !== 'loading') ready();
    else document.addEventListener('DOMContentLoaded', ready);
  })();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-blend-split"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. Without this guard
   every save registers another full set of document listeners, and after a
   handful of saves a single click runs dozens of stale handlers holding
   detached nodes — which is what locks the editor tab up. */
if (!window.__bwSplitBound) {
  window.__bwSplitBound = true;

(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bind(panel) {
    /* Randomised tilt: the packshot leans a slightly different way each time,
       so repeated hovers do not feel like a canned loop. Same fixed +/-3.5deg
       spread the blend hero rolls for its packet.

       The range is a constant, NOT read back off --bwp-tilt. Seeding each roll
       from the previous one — which is what this did before — shrinks the
       magnitude every hover, because each result is drawn from a band narrower
       than the value it was seeded with. After a handful of hovers the tilt had
       decayed to nothing and the effect looked broken. */
    if (panel.dataset.bwRandomTilt === 'true' && !reduce.matches) {
      panel.addEventListener('mouseenter', function () {
        panel.style.setProperty('--bwp-tilt', (Math.random() * 7 - 3.5).toFixed(2) + 'deg');
      });
    }

    /* Pointer-tracked lean. Pointer-fine only: on a touchscreen there is no
       hover state to track and the sachet would simply jump on tap. */
    if (panel.dataset.bwPointerTilt === 'true' && !reduce.matches &&
        window.matchMedia('(pointer: fine)').matches) {
      var img = panel.querySelector('.bw-panel__img');
      var frame = 0;
      var maxTilt = parseFloat(getComputedStyle(panel).getPropertyValue('--bwp-tilt-max')) || 9;

      panel.addEventListener('pointermove', function (e) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = 0;
          var r = panel.getBoundingClientRect();
          /* -1..1 from panel centre on each axis */
          var nx = (e.clientX - r.left) / r.width * 2 - 1;
          var ny = (e.clientY - r.top) / r.height * 2 - 1;
          panel.classList.add('is-tracking');
          panel.style.setProperty('--bwp-ry', (nx * maxTilt).toFixed(2) + 'deg');
          panel.style.setProperty('--bwp-rx', (-ny * maxTilt).toFixed(2) + 'deg');
        });
      });

      panel.addEventListener('pointerleave', function () {
        panel.classList.remove('is-tracking');
        panel.style.setProperty('--bwp-ry', '0deg');
        panel.style.setProperty('--bwp-rx', '0deg');
      });
    }

    /* Clicking a panel can also set the site blend, so arriving on the linked
       page finds the palette already switched rather than flipping after. */
    var blend = panel.dataset.bwSetBlend;
    if (blend) {
      panel.addEventListener('click', function () {
        document.documentElement.setAttribute('data-bw-blend', blend);
        try { localStorage.setItem('bw-blend', blend); } catch (e) {}
        document.dispatchEvent(new CustomEvent('bw:blendchange', { detail: { blend: blend } }));
      });
    }
  }

  function init() { document.querySelectorAll('[data-bw-panel]').forEach(bind); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bw-panel]').forEach(bind);
  });
})();

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-build-box"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into one bundle and the theme
   editor re-runs that bundle on each save, so document-level listeners have
   to be registered exactly once. */
if (!window.__bwBuildBoxBound) {
  window.__bwBuildBoxBound = true;

  (function () {
    function init(root) {
      if (!root || root.dataset.bwBbReady === '1') return;
      root.dataset.bwBbReady = '1';

      var radios     = Array.prototype.slice.call(root.querySelectorAll('[data-bb-pack]'));
      var planGroup  = root.querySelector('[data-bb-plan]');
      var planBtns   = Array.prototype.slice.call(root.querySelectorAll('[data-bb-plan-set]'));
      var mix        = root.querySelector('[data-bb-mix]');
      var mixRead    = root.querySelector('[data-bb-mixread]');
      var mixLabel   = root.querySelector('[data-bb-mixlabel]');
      var moveN      = root.querySelector('[data-bb-move-n]');
      var restN      = root.querySelector('[data-bb-rest-n]');
      var nudges     = Array.prototype.slice.call(root.querySelectorAll('[data-bb-blend]'));
      var mixStep    = parseInt(root.dataset.mixStep, 10) || 1;
      var total      = root.querySelector('[data-bb-total]');
      var line1      = root.querySelector('[data-bb-line-1]');
      var line2      = root.querySelector('[data-bb-line-2]');
      var cta        = root.querySelector('[data-bb-checkout]');
      var ctaLabel   = root.querySelector('[data-bb-cta-label]');
      var errorEl    = root.querySelector('[data-bb-error]');

      var memberLive = root.dataset.memberLive === 'true';
      /* Liquid already decided this and painted the thumb to match. Reading it
         back rather than re-deriving it keeps the two in step. */
      var plan       = root.dataset.startPlan === 'member' && memberLive ? 'member' : 'once';
      var moveCount  = 0;
      var mixSettle  = null;

      if (!radios.length) return;

      function selected() {
        for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
        radios[0].checked = true;
        return radios[0];
      }

      function labels() {
        return {
          move:    root.dataset.labelMove    || 'Move',
          restore: root.dataset.labelRestore || 'Restore'
        };
      }

      /* --- reporting ------------------------------------------------------

         Every event carries the SAME shape: the full state of the configurator
         at the moment something happened, not just the thing that changed.
         A "plan toggled" event that says only "member" cannot answer which
         pack that was on, and joining it back to the preceding pack event in
         the warehouse is guesswork the moment two events land in the same
         second. Sending the whole snapshot each time costs a few bytes and
         makes every event independently answerable.

         Money goes out as a decimal in the store's currency, from the raw
         cents on the card — never parsed back out of the formatted string,
         for the reason given where those attributes are rendered. */
      function snapshot(r) {
        var p     = activePlan();
        var max   = splitOf(r);
        var cents = parseInt(p === 'member' ? r.dataset.memberCents : r.dataset.onceCents, 10);

        return {
          pack:            r.dataset.name || null,
          variant_id:      parseInt(r.dataset.variant, 10) || null,
          plan:            p,
          selling_plan_id: p === 'member' && r.dataset.plan ? parseInt(r.dataset.plan, 10) : null,
          servings:        parseInt(r.dataset.servings, 10) || null,
          value:           isNaN(cents) ? null : cents / 100,
          currency:        root.dataset.currency || null,
          /* Null rather than 0 for a fixed pack. Zero is a real mix — a box
             that is all Restore — and averaging the two together would quietly
             drag the reported mix toward Restore across the whole store. */
          move:            max > 0 ? moveCount : null,
          restore:         max > 0 ? max - moveCount : null,
          pack_size:       max > 0 ? max : null,
          section_id:      root.dataset.sectionId || null
        };
      }

      function report(name, r, extra) {
        if (typeof window.bwTrack !== 'function') return;
        var payload = snapshot(r || selected());
        if (extra) {
          for (var k in extra) {
            if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k];
          }
        }
        window.bwTrack(name, payload);
      }

      /* --- mix ------------------------------------------------------------ */

      /* Two different questions, deliberately kept apart:

         splitOf()   — does this pack contain both blends at all?
         adjustable()— may the CUSTOMER change that split?

         Collapsing them is the obvious mistake. A fixed pack still has a
         composition the warehouse has to know about, so a Daily System that
         ships 30 Move + 30 Restore must still put that on the order even
         though no control is shown. Only the control is conditional. */
      function splitOf(r) { return parseInt(r.dataset.mixMax, 10) || 0; }

      function adjustable(r) { return r.dataset.mix === 'true' && splitOf(r) > 0; }

      function defaultMove(r) {
        var max = splitOf(r);
        var def = parseInt(r.dataset.mixDefault, 10);
        if (isNaN(def)) def = Math.round(max / 2);
        return Math.max(0, Math.min(def, max));
      }

      function syncMix(r, resetValue) {
        if (!adjustable(r)) {
          if (mix) mix.hidden = true;
          /* The pack's own split still becomes the order's split. */
          moveCount = defaultMove(r);
          return;
        }

        if (mix) mix.hidden = false;

        var max = splitOf(r);
        if (resetValue) moveCount = defaultMove(r);
        moveCount = Math.max(0, Math.min(moveCount, max));

        paintMix(r);
      }

      function paintMix(r) {
        if (!mix || mix.hidden) return;
        var max = splitOf(r);
        /* Derived, never stored. The two counters cannot drift apart because
           there is only one number to drift. */
        var rest = max - moveCount;
        var l = labels();
        var text = moveCount + ' ' + l.move + ' + ' + rest + ' ' + l.restore;

        if (mixRead) mixRead.textContent = text;
        if (moveN) moveN.textContent = String(moveCount);
        if (restN) restN.textContent = String(rest);

        /* The heading counts the box it is actually splitting, so a 30-pack
           and a 60-pack do not share one vague label. */
        if (mixLabel) {
          if (!mixLabel.dataset.base) mixLabel.dataset.base = mixLabel.textContent.trim();
          mixLabel.textContent = mixLabel.dataset.base.replace('[count]', String(max));
        }

        /* A nudge is dead when its own blend is already at the limit: you
           cannot take a stick from a pile that has none, and you cannot add
           one to a box that is already all that blend. */
        nudges.forEach(function (b) {
          var isMove = b.dataset.bbBlend === 'move';
          var own = isMove ? moveCount : rest;
          b.disabled = b.dataset.bbDir === 'down' ? own <= 0 : own >= max;
        });
      }

      /* --- summary -------------------------------------------------------- */
      function activePlan() { return memberLive && plan === 'member' ? 'member' : 'once'; }

      function paintSummary() {
        var r = selected();
        var p = activePlan();
        var d = r.dataset;

        var price = p === 'member' ? d.memberPrice : d.oncePrice;
        var per   = p === 'member' ? d.memberPer   : d.oncePer;
        var save  = p === 'member' ? d.memberSave  : d.onceSave;
        var saveC = parseInt(p === 'member' ? d.memberSaveCents : d.onceSaveCents, 10) || 0;
        var wired = d.unwired !== 'true';

        if (total) total.textContent = wired ? price : '—';

        /* Line 1: what you are buying. Line 2: why it is a good deal. */
        var bits = [];
        if (d.name) bits.push(d.name);
        if (d.servings && d.servings !== '0') bits.push(d.servings + ' ' + (d.servingsLabel || 'servings'));
        if (p === 'member' && d.cadence) bits.push(d.cadence);
        if (line1) line1.textContent = bits.join(' · ');

        /* Reserving: the split is still worth stating, the arithmetic on a
           price nobody is being charged is not. Same rule the cards apply in
           Liquid — see the reserve note at the top of this section. */
        var reserving = root.dataset.reserve === 'true';
        var deal = [];
        if (!reserving && wired && per && d.servings !== '0') {
          deal.push(per + ' / ' + (root.dataset.perUnit || 'serving'));
        }
        if (!reserving && wired && saveC > 0) deal.push('Save ' + save);
        /* Keyed to the pack having a split, not to the control being visible —
           a fixed 30 + 30 is still worth stating in the summary. */
        var splitMax = splitOf(r);
        if (splitMax > 0) {
          var l = labels();
          deal.push(moveCount + ' ' + l.move + ' + ' + (splitMax - moveCount) + ' ' + l.restore);
        }
        if (line2) line2.textContent = deal.join(' · ');

        if (cta) {
          var sellable = wired && d.available !== 'false';
          cta.disabled = !sellable;
          if (ctaLabel) {
            /* The label rendered by Liquid is the base. Cached on first paint
               because every repaint after this one overwrites it with
               "Checkout · $126.65" — reading it back would compound. */
            if (!ctaLabel.dataset.base) ctaLabel.dataset.base = ctaLabel.textContent.trim();
            ctaLabel.textContent = sellable && root.dataset.ctaTotal === 'true'
              ? ctaLabel.dataset.base + ' · ' + price
              : ctaLabel.dataset.base;
          }
        }
      }

      function paintCards() {
        /* Card prices follow the plan toggle too, otherwise the card says one
           number and the bar below it says another. */
        radios.forEach(function (r) {
          var card = root.querySelector('label[for="' + r.id + '"]');
          if (!card) return;
          var priceEl = card.querySelector('[data-bb-card-price]');
          var perEl   = card.querySelector('[data-bb-card-per]');
          if (r.dataset.unwired === 'true') return;

          var p = activePlan();
          if (priceEl) priceEl.textContent = p === 'member' ? r.dataset.memberPrice : r.dataset.oncePrice;
          if (perEl && r.dataset.servings !== '0') {
            var per = p === 'member' ? r.dataset.memberPer : r.dataset.oncePer;
            var save = p === 'member' ? r.dataset.memberSave : r.dataset.onceSave;
            var saveC = parseInt(p === 'member' ? r.dataset.memberSaveCents : r.dataset.onceSaveCents, 10) || 0;
            var txt = per + ' / ' + (root.dataset.perUnit || 'serving');
            if (saveC > 0) txt += ' · Save ' + save;
            perEl.textContent = txt;
          }
        });
      }

      function paintAll(resetMix) {
        var r = selected();
        syncMix(r, resetMix);
        paintCards();
        paintSummary();
      }

      /* --- events --------------------------------------------------------- */
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (errorEl) errorEl.hidden = true;
          paintAll(true);
          /* After paintAll, so the mix in the payload is the one the reset
             just produced rather than the previous pack's. */
          report('bw_pack_selected', r);
        });
      });

      planBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var next = b.dataset.bbPlanSet;
          if (next === 'member' && !memberLive) return;
          plan = next;
          if (planGroup) planGroup.setAttribute('data-active', plan);
          planBtns.forEach(function (x) {
            x.setAttribute('aria-checked', String(x.dataset.bbPlanSet === plan));
          });
          paintCards();
          paintSummary();
          report('bw_plan_selected', null, { plan_available: memberLive });
        });
      });

      nudges.forEach(function (b) {
        b.addEventListener('click', function () {
          var r = selected();
          var max = splitOf(r);

          /* Everything resolves to a change in the ONE stored number. A
             Restore nudge is the same operation with the sign flipped, which
             is why the two counters always sum to the pack size without
             anything having to reconcile them afterwards. */
          var sign = b.dataset.bbBlend === 'move' ? 1 : -1;
          if (b.dataset.bbDir === 'down') sign = -sign;

          moveCount = Math.max(0, Math.min(max, moveCount + sign * mixStep));
          paintMix(r);
          paintSummary();

          /* Debounced on purpose. Nudging from 30 Move to 20 is ten clicks,
             and reporting each one would put nine values into the property
             that the visitor never chose and bury the one they did. The timer
             restarts on every click, so what gets reported is the mix they
             stopped on. mixSettle is cleared on unload with the countdown. */
          if (mixSettle) clearTimeout(mixSettle);
          mixSettle = setTimeout(function () {
            mixSettle = null;
            report('bw_mix_adjusted', r);
          }, 800);
        });
      });

      /* --- checkout ------------------------------------------------------- */
      if (cta) {
        cta.addEventListener('click', function () {
          var r = selected();
          if (r.dataset.unwired === 'true' || !r.dataset.variant) {
            /* Worth an event of its own. A pack card with no variant behind it
               is a merchandising mistake, not a visitor decision, and it is
               invisible in every other report: the click happens, nothing moves,
               and the funnel just shows a drop-off at the CTA. */
            report('bw_checkout_blocked', r, { reason: 'unwired_pack' });
            return;
          }

          var props = {};
          var max = splitOf(r);
          if (max > 0) {
            var l = labels();
            props[l.move] = String(moveCount);
            props[l.restore] = String(max - moveCount);
          }

          var item = { id: Number(r.dataset.variant), quantity: 1 };
          if (Object.keys(props).length) item.properties = props;
          if (activePlan() === 'member' && r.dataset.plan) {
            item.selling_plan = Number(r.dataset.plan);
          }

          cta.classList.add('is-busy');
          if (errorEl) errorEl.hidden = true;

          /* Fired on intent, before the network call. If it were fired on
             success instead, every add that failed would be missing from both
             sides of the funnel and the checkout step would look healthier
             than it is — the failures are exactly what this is here to find. */
          report('bw_checkout_started', r);

          fetch(root.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] })
          })
            .then(function (res) {
              return res.json().then(function (body) {
                if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
                return body;
              });
            })
            .then(function () {
              /* Redirect only once the add is confirmed. Firing both at once
                 races the cart write against the navigation and lands people
                 on an empty checkout. */
              window.location.href = root.dataset.checkoutUrl;
            })
            .catch(function (err) {
              cta.classList.remove('is-busy');
              if (errorEl) {
                errorEl.textContent = err.message || 'Something went wrong. Please try again.';
                errorEl.hidden = false;
              }
              /* The most valuable event here. A failed add is otherwise
                 completely silent — the visitor sees a message, leaves, and the
                 store owner sees only a session that did not convert. Sold-out
                 variants and expired selling plans both land here. */
              report('bw_checkout_failed', r, { message: String(err && err.message || 'unknown') });
            });
        });
      }

      /* --- countdown ------------------------------------------------------ */
      var ship = root.querySelector('[data-bb-ship]');
      if (ship) {
        var shipText = root.querySelector('[data-bb-ship-text]');
        var cutoff = parseInt(root.dataset.cutoffHour, 10);

        if (!isNaN(cutoff)) {
          /* Shop offset arrives as "-0500". Convert to minutes, then shift the
             visitor's UTC time into store-local time so the deadline is the
             warehouse's, not the visitor's. */
          var raw = root.dataset.shopOffset || '+0000';
          var sign = raw.charAt(0) === '-' ? -1 : 1;
          var offMin = sign * (parseInt(raw.substr(1, 2), 10) * 60 + parseInt(raw.substr(3, 2), 10));

          var tick = function () {
            var now = new Date();
            var shopMs = now.getTime() + now.getTimezoneOffset() * 60000 + offMin * 60000;
            var shop = new Date(shopMs);

            var deadline = new Date(shopMs);
            deadline.setHours(cutoff, 0, 0, 0);

            if (shop >= deadline) {
              shipText.textContent = root.dataset.countdownAfter || '';
              ship.hidden = !shipText.textContent;
              return;
            }

            var left = Math.floor((deadline - shop) / 1000);
            var h = Math.floor(left / 3600);
            var m = Math.floor((left % 3600) / 60);
            var sec = left % 60;
            var pad = function (n) { return n < 10 ? '0' + n : String(n); };

            shipText.textContent =
              (root.dataset.countdownPrefix || '') + ' ' + pad(h) + ':' + pad(m) + ':' + pad(sec);
            ship.hidden = false;
          };

          tick();
          /* Parked on the node so the unload handler can stop it. Left
             running, each theme-editor save would strand another interval
             ticking against a detached element. */
          root._bwShipTimer = setInterval(tick, 1000);
        }
      }

      /* --- handoff from the homepage ---------------------------------------

         The homepage offer section lists these same three packs and links here
         with ?pack=<slug>. Honouring it is what makes that click a step forward
         rather than the same choice asked twice: whoever picked Starter over
         there arrives with Starter already selected and the mix control set
         for it.

         Matched on the slug rather than the index, because the index changes
         the moment the packs are reordered and a stale link would then open
         the wrong one. Read before the first paintAll, so the pack is chosen
         while the section is still painting its initial state — selecting it
         afterwards would show the default pack for a frame and then switch. */
      try {
        var want = new URLSearchParams(window.location.search).get('pack');
        if (want) {
          want = want.toLowerCase();
          for (var wi = 0; wi < radios.length; wi++) {
            if (radios[wi].dataset.slug === want) { radios[wi].checked = true; break; }
          }
        }
      } catch (e) {
        /* A malformed query string is not a reason to leave the section
           unpainted — fall through to the default pack. */
      }

      paintAll(true);

      /* --- impression -----------------------------------------------------

         The denominator. Without it every other event here is a count with
         nothing to divide by: 40 checkout clicks is a triumph or a disaster
         depending on whether 200 people or 20,000 saw the section.

         Fires on visibility rather than on init because the section can sit
         below the fold — counting a render as a view would inflate the
         denominator with people who never scrolled to it. Once only; the
         observer disconnects itself, so scrolling back up does not double-
         count a single session. */
      if (typeof IntersectionObserver === 'function') {
        var seen = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            seen.disconnect();
            report('bw_build_box_viewed', null, { packs_shown: radios.length, member_available: memberLive });
            return;
          }
        }, { threshold: 0.25 });
        seen.observe(root);
        root._bwSeenObserver = seen;
      } else {
        report('bw_build_box_viewed', null, { packs_shown: radios.length, member_available: memberLive });
      }

      root._bwClearTimers = function () {
        if (mixSettle) { clearTimeout(mixSettle); mixSettle = null; }
      };
    }

    function boot() {
      document.querySelectorAll('[data-bw-build-box]').forEach(init);
    }

    /* Editor re-render: the old node is replaced, so the ready flag goes with
       it and init runs cleanly on the new one. */
    document.addEventListener('shopify:section:load', boot);

    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('[data-bw-build-box]') : null;
      if (el && el._bwShipTimer) clearInterval(el._bwShipTimer);
      if (el && el._bwSeenObserver) el._bwSeenObserver.disconnect();
      if (el && el._bwClearTimers) el._bwClearTimers();
    });

    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
  })();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-header"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. Without this guard
   every save registers another full set of document listeners, and after a
   handful of saves a single click runs dozens of stale handlers holding
   detached nodes — which is what locks the editor tab up. */
if (!window.__bwHeaderBound) {
  window.__bwHeaderBound = true;

(function () {
  var KEY = 'bw-blend';

  /* ---- blend switching ---------------------------------------------- */
  function current() {
    return document.documentElement.getAttribute('data-bw-blend') === 'restore' ? 'restore' : 'move';
  }

  function sync() {
    var v = current();
    document.querySelectorAll('[data-bw-blend-set]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn.dataset.bwBlendSet === v));
    });
  }

  function setBlend(v) {
    document.documentElement.setAttribute('data-bw-blend', v);
    try { localStorage.setItem(KEY, v); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('bw:blendchange', { detail: { blend: v } }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bw-blend-set]');
    if (btn) setBlend(btn.dataset.bwBlendSet);
  });

  /* ---- mobile drawer ------------------------------------------------- */
  function bindDrawer(header) {
    var drawer = header.querySelector('[data-bw-drawer]');
    var opener = header.querySelector('[data-bw-drawer-open]');
    if (!drawer || !opener) return;

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      drawer.removeAttribute('inert');
      /* Force a frame so the transform transition runs from its start value
         rather than being collapsed with the display change. */
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        opener.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var first = drawer.querySelector('a, button:not([tabindex="-1"])');
        if (first) first.focus();
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      drawer.setAttribute('inert', '');
      var panel = drawer.querySelector('.bw-drawer__panel');
      var done = function () { drawer.hidden = true; };
      if (panel) panel.addEventListener('transitionend', done, { once: true });
      else done();
      if (lastFocus) lastFocus.focus();
    }

    opener.addEventListener('click', open);
    drawer.querySelectorAll('[data-bw-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---- floating switcher --------------------------------------------- */
  /* Above 990px base.css makes .page-wrapper the scroller (height:100dvh;
     overflow-y:auto) and the window never scrolls, so a scroll listener on
     window would fire on mobile only. IntersectionObserver against the
     implicit root is clipped by every scrolling ancestor, so one observer
     covers both cases — and it costs nothing per frame. */
  var floatObserver = null;

  function bindFloat() {
    if (floatObserver) { floatObserver.disconnect(); floatObserver = null; }

    var panel = document.querySelector('[data-bw-float-switch]');
    if (!panel) return;

    // What the pill waits for: the page's FIRST section leaving the viewport,
    // not the header leaving it.
    //
    // Watching the header cannot work while the header is sticky — it never
    // leaves the viewport, so it never stops intersecting and the pill never
    // appeared at all. The first section is the one the visitor has to scroll
    // past before a floating control is worth showing, which is also what the
    // pill is for: changing blend once the page's own switcher is long gone.
    var main = document.getElementById('MainContent') || document.querySelector('main');
    var target = main && main.querySelector('.shopify-section');
    if (!target) target = document.querySelector('[data-bw-header]');
    if (!target) return;

    function show(on) {
      panel.classList.toggle('is-visible', on);
      if (on) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    }

    floatObserver = new IntersectionObserver(function (entries) {
      show(!entries[0].isIntersecting);
    }, { threshold: 0 });

    floatObserver.observe(target);
  }

  var stuckObserver;

  function bindStuck() {
    var sentinel = document.querySelector('[data-bw-header-sentinel]');
    var header = document.querySelector('[data-bw-header]');
    if (!sentinel || !header || stuckObserver) return;

    // Same reasoning as the float observer above: above 990px base.css makes
    // .page-wrapper the scroller and the window never scrolls, so a scroll
    // listener would fire on mobile only. One observer covers both.
    stuckObserver = new IntersectionObserver(function (entries) {
      header.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 0 });

    stuckObserver.observe(sentinel);
  }

  function init() {
    sync();
    bindStuck();
    document.querySelectorAll('[data-bw-header]').forEach(bindDrawer);
    bindFloat();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target.querySelector('[data-bw-header]');
    if (h) { bindDrawer(h); bindFloat(); stuckObserver = null; bindStuck(); sync(); }
  });
})();

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-hero-split"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. Without this guard
   every save registers another full set of document listeners, and after a
   handful of saves a single click runs dozens of stale handlers holding
   detached nodes — which is what locks the editor tab up. */
if (!window.__bwHeroBound) {
  window.__bwHeroBound = true;

(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bind(root) {
    if (!root || root.dataset.bwParallax !== 'true' || reduce.matches) return;
    var drifts = root.querySelectorAll('[data-bw-drift]');
    if (!drifts.length) return;

    var live = false, frame = 0;

    var io = new IntersectionObserver(function (entries) {
      live = entries[0].isIntersecting;
      if (live) read();
    }, { threshold: 0 });
    io.observe(root);

    function read() {
      frame = 0;
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      root.style.setProperty('--bwf-p', ((vh / 2 - (r.top + r.height / 2)) / vh).toFixed(4));
    }

    function onScroll() { if (live && !frame) frame = requestAnimationFrame(read); }

    read();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  function init() { document.querySelectorAll('[data-bw-hero]').forEach(bind); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    bind(e.target.querySelector('[data-bw-hero]'));
  });
})();

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-marquee"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. Without this guard
   every save registers another full set of document listeners, and after a
   handful of saves a single click runs dozens of stale handlers holding
   detached nodes — which is what locks the editor tab up. */
if (!window.__bwMarqueeBound) {
  window.__bwMarqueeBound = true;

(function () {
  function measure(el) {
    var track = el.querySelector('[data-bw-track]');
    if (!track) return;

    var groups = track.querySelectorAll('[data-bw-group]');
    if (!groups.length) return;

    var one = groups[0];
    var w = one.getBoundingClientRect().width;
    if (!w) return;

    /* Clone until the track spans at least twice the viewport, so a short
       phrase list cannot leave a visible gap on a wide screen. */
    var need = Math.max(2, Math.ceil((el.getBoundingClientRect().width * 2) / w));
    var have = groups.length;
    for (var i = have; i < need; i++) {
      var clone = one.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    var speed = parseFloat(el.dataset.speed) || 70;
    el.style.setProperty('--bwm-shift', w + 'px');
    el.style.setProperty('--bwm-dur', (w / speed).toFixed(2) + 's');
  }

  function all() { document.querySelectorAll('[data-bw-marquee]').forEach(measure); }

  function init() {
    all();
    /* Fonts change metrics: Plakette is font-display:block, so a measurement
       taken before it lands would be wrong by a wide margin. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(all, 200);
    });

    /* Restore copy can be a different length, so re-measure on blend change. */
    document.addEventListener('bw:blendchange', function () { setTimeout(all, 50); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    var m = e.target.querySelector('[data-bw-marquee]');
    if (m) measure(m);
  });
})();

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
